import fp from 'lodash/fp'
import { types } from 'mobx-state-tree'
import {
  TRIGGER_CATEGORIES,
  TRIGGER_BINARY_WINNER,
} from 'constants/trigger.types'
import { STATUSES } from 'constants/data.statuses'

import { Team } from '../entities/team'
import { Athlete } from '../entities/athlete'
import { Event } from '../entities/event'

export const Trigger = types
  .model('TriggerModel', {
    id: types.identifierNumber,
    binaryWinner: types.maybeNull(types.string),
    category: types.enumeration('TriggerCategory', [
      TRIGGER_CATEGORIES.ATHLETE,
      TRIGGER_CATEGORIES.MATCH,
      TRIGGER_CATEGORIES.TEAM,
    ]),
    subCategory: types.string,
    triggerCondition: types.maybeNull(types.string),
    score: types.maybeNull(types.number),
    athlete: types.maybeNull(types.reference(Athlete)),
    team: types.maybeNull(types.reference(Team)),
    event: types.maybeNull(types.reference(Event)),
  })
  .views((self) => ({
    get logo() {
      if (!self.binaryWinner) {
        // For custom events that don't have a binary winner
        return self.event?.tournament?.logo || null;
      }

      switch (self.binaryWinner) {
        case TRIGGER_BINARY_WINNER.TEAM_A:
          return self.event?.teamOne?.logo
        case TRIGGER_BINARY_WINNER.TEAM_B:
          return self.event?.teamTwo?.logo
        default:
          return null
      }
    },

    get description() {
      if (self.event?.isCustomEvent) {
        return self.event.matchName || "Custom Event";
      }

      switch (self.binaryWinner) {
        case TRIGGER_BINARY_WINNER.TEAM_A:
          return `When team ${self.event?.teamA} defeats ${self.event?.teamB}`
        case TRIGGER_BINARY_WINNER.TEAM_B:
          return `When team ${self.event?.teamB} defeats ${self.event?.teamA}`
        case TRIGGER_BINARY_WINNER.DRAW:
          return 'When match result is a draw'
        default:
          return STATUSES.NOT_AVAILABLE
      }
    },

    getBinnaryWinner() {
      if (!self.binaryWinner || self.event?.isCustomEvent) {
        return "N/A";
      }

      switch (self.binaryWinner) {
        case TRIGGER_BINARY_WINNER.TEAM_A:
          return self.event?.teamA
        case TRIGGER_BINARY_WINNER.TEAM_B:
          return self.event?.teamB
        case TRIGGER_BINARY_WINNER.DRAW:
          return fp.capitalize(TRIGGER_BINARY_WINNER.DRAW)
        default:
          return self.binaryWinner
      }
    },
  }))
